import React, { useCallback, useRef, memo, MouseEvent } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import styled from "styled-components";
import { IconButton, Tooltip } from "@mui/material";

import { appStateMutate } from "stores/modules/app.state/operations";
import { getIsRoleAudience } from "stores/modules/entities.room.members/selectors";
import { HighlightAlt } from "@mui/icons-material";
import { getAppState } from "stores/modules/app.state/selectors";
import { useTranslation } from "react-i18next";
import { IS_APPLE } from "modules/device";

const SelectModeChangeButton = () => {
  const [t] = useTranslation();
  const dispatch = useAppDispatch();
  const anchorEl = useRef(null);

  const isRoleAudience = useAppSelector(getIsRoleAudience);
  const isMultiSelectMode = useAppSelector((state) =>
    getAppState(state, "isMultiSelectMode")
  );

  const toggleMultiSelectMode = useCallback(() => {
    dispatch(
      appStateMutate((state) => {
        state.isMultiSelectMode = !state.isMultiSelectMode;
      })
    );
  }, [dispatch]);

  return (
    <div onDoubleClick={stopPropagation}>
      <SelectModeChangeBox>
        <Tooltip
          title={
            IS_APPLE ? `${t("Command + ドラッグ")}` : `${t("Ctrl + ドラッグ")}`
          }
          placement="top"
        >
          <IconButton
            onClick={toggleMultiSelectMode}
            ref={anchorEl}
            disabled={isRoleAudience}
            size="small"
            color={isMultiSelectMode ? "primary" : "default"}
            sx={{
              filter: "drop-shadow(0 0 2px rgba(0, 0, 0, 0.4))",
            }}
          >
            <HighlightAlt />
          </IconButton>
        </Tooltip>
      </SelectModeChangeBox>
    </div>
  );
};

const stopPropagation = (event: MouseEvent) => event.stopPropagation();

const SelectModeChangeBox = styled.div`
  position: absolute;
  right: 29px;
  bottom: 230px;
  z-index: 103;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export default memo(SelectModeChangeButton);
